import axios from 'axios';

const HR_BASE_URL = 'http://localhost:5002/api';

export const fetchCandidateStatus = async (interviewId) => {
  try {
    const res = await axios.get(`${HR_BASE_URL}/candidate/interviews/${interviewId}/status`);
    return res.data.data;
  } catch (err) {
    console.error('❌ Failed to fetch candidate HR status:', err);
    return null;
  }
};
